module.exports = __webpack_public_path__ + "img/f-thermometer-img5-2.84c4bc56.png";